// extracted by mini-css-extract-plugin
export var footer = "_nr-5";
export var fulfillmentInput = "_nr-0";
export var shipDateInput = "_nr-1";
export var shipmentModal = "_nr-2";
export var shipmentModalContent = "_nr-3";
export var tableContainer = "_nr-4";